export default __webpack_public_path__ + "img/ImageOptimize-icon.svg";